
import React from 'react';

interface HeaderProps {
  onAdminClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onAdminClick }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-8 py-6 glass border-b-0">
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 accent-gradient rounded-lg flex items-center justify-center">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <a href="/" className="font-display text-xl font-bold tracking-tighter uppercase">deal<span className="text-blue-500">mycar</span></a>
      </div>
      
      <nav className="hidden md:flex gap-8 text-sm font-medium text-gray-400">
        <a href="#how-it-works" className="hover:text-white transition-colors">How it works</a>
      </nav>

      <button 
        onClick={onAdminClick}
        className="px-5 py-2 rounded-full border border-white/10 hover:border-white/30 transition-all text-sm font-semibold"
      >
        Admin Portal
      </button>
    </header>
  );
};

export default Header;
